import React, { Component, FormEvent } from "react";
import { SearchRequest } from "../../rpc/admin/search_pb";
import Adapter, { SortField } from "./adapter";

interface SortProps {
    adapter: Adapter;
    selectedField: string ;
    direction: SearchRequest.Direction;
}

interface SortState { }

class Sort extends Component<SortProps, SortState> {

    private sortFields: SortField[] = [
        {
            label: 'Relevance',
            field: '',
            direction: SearchRequest.Direction.DIRECTION_ASCENDING,
        },
        {
            label: 'Price (low to high)',
            field: 'price',
            direction: SearchRequest.Direction.DIRECTION_ASCENDING,
        },
        {
            label: 'Price (high to low)',
            field: 'price',
            direction: SearchRequest.Direction.DIRECTION_DESCENDING,
        },
        {
            label: 'Product Name',
            field: 'name',
            direction: SearchRequest.Direction.DIRECTION_ASCENDING,
        },
        {
            label: 'Quantity On Hand (low to high)',
            field: 'qoh',
            direction: SearchRequest.Direction.DIRECTION_ASCENDING,
        },
        {
            label: 'Quantity On Hand (high to low)',
            field: 'qoh',
            direction: SearchRequest.Direction.DIRECTION_DESCENDING,
        },
    ];


    private makeValue(sortField: SortField): string {
        if (sortField.field === '') {
            return 'default-sort-field-' + sortField.direction;
        }
        return sortField.field + '-' + sortField.direction;
    }

    onSelectChange = (e: FormEvent<HTMLSelectElement>) => {
        e.preventDefault();
        this.sortFields.forEach((sortField) => {
            if (this.makeValue(sortField) === e.currentTarget.value) {
                if (sortField.direction === SearchRequest.Direction.DIRECTION_DESCENDING) {
                    this.props.adapter!.setSortOrder(sortField.field, SearchRequest.Direction.DIRECTION_DESCENDING);
                } else {
                    this.props.adapter!.setSortOrder(sortField.field, SearchRequest.Direction.DIRECTION_ASCENDING);
                }
            }
        });
    }

    render() {
        let index = 0;

        const selected = this.makeValue({
            label: '',
            field: this.props.selectedField,
            direction: this.props.direction,
        });

        return (
            <div className="search-sort">
                <h2>Sort</h2>
                <div className="select is-small">
                    <select value={selected} onChange={this.onSelectChange}>
                    {
                        this.sortFields.map((sortField) => {
                            return <option className="is-medium" key={'sort-field-' + (index++)} value={this.makeValue(sortField)}>{sortField.label}</option>;
                        })
                    }
                    </select>
                </div>
            </div>
        );
    }
}

export default Sort;